<template>
  <div class="answer_area">
    <div style="margin-left:-120px;position:relative">
      <div style="position: absolute;left: 10px;top: 0;">
        <i v-if="!data.controlName">正确答案：</i>
      </div>
        <!--多选框（A1A2A3案例分析/////竞赛理论题可单选/多选）-->
      <el-checkbox-group v-if="data.checked=='multiple'" v-model="controlValue" @change="checkChange" size="medium">
        <el-checkbox-button class="choose-box" v-for="(item,i) in getData" :key="i" :label="item.serialNum">{{item.serialNum}}</el-checkbox-button>
      </el-checkbox-group>
      <!--单选下拉-->
      <el-radio-group v-else v-model="data.controlValue" size="medium">
        <el-radio-button
          v-for="(item,i) in getData"
          :key="i"
          :label="item.serialNum"
          :value="item.serialNum"
        ></el-radio-button>
      </el-radio-group>
      <!-- 填空题 -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxSelect',
  inject: ['formData'],
  props: {
    data: {
      type: Object,
      required: true
    },
    keyName: String
  },
  data () {
    return {
      controlValue: [],
      parsing_con: '',
      show_pars: true
    }
  },
  computed: {
    getData () {
      // 获取回答区答案
    //   let arr
    //   this.formData.json.question_answer.forEach(v => {
    //     if (Array.isArray(v)) {
    //       v.forEach(j => {
    //         arr = v.filter(k => { return k.controlType === 'InputUploadImg' });
    //       })
    //     } else {
    //       arr = this.formData[2].filter(k => { return k.controlType === 'InputUploadImg' });
    //     }
    //   })
    //   return arr.length ? arr[0].controls : []
    }
  },
  watch: {
    'data.controlValue': {
      handler (oldValue, newValue) {
        if (this.data.controlValue === '') {
          this.controlValue = []
        } else {
          this.controlValue = this.data.checked ? this.data.controlValue.split(',') : [];
        }
      }
    }
  },
  methods: {
    checkChange (v) {
      this.data.controlValue = v.sort().join(',')
    }
  },
  created () {
    this.controlValue = this.data.checked ? this.data.controlValue.split(',') : false;
    this.controlValue = this.controlValue && this.controlValue.filter(v => v)
  }
}
</script>
<style scoped lang='scss'>
/deep/.choose-box .el-checkbox__inner{
  width: 25px !important;
  height: 25px !important;
}
/deep/.choose-box .el-checkbox__inner::after{
  height: 10px;
  width: 4px;
  top: 5px;
  left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/checkboxSelect.vue